import { SVGS } from '~/assets/assetsPath';

export const contactInfoList = [
    {
        id: 1,
        icon: SVGS.IconLocation,
        text: '16A Le Loi, Vinh Trai Ward, Lang Son City',
    },
    {
        id: 2,
        icon: SVGS.IconPhone,
        text: '090 347 41 86',
    },
    {
        id: 3,
        icon: SVGS.IconEmail,
        text: 'homespa@hitek.com.vn',
    },
    {
        id: 4,
        icon: SVGS.IconTimer,
        text: '08:30 - 18:00, Monday - Saturday',
    },
];
